import React from 'react';
import { withAdminModule } from '../../helpers/hoc/withAdminModule';

import './SkinnyBanner.less';

export const SkinnyBannerView = ({ module }) => (
  <div className="col-xs-12 col-md-12 banner-promo-module">
    <a href={module.link_path} rel="noopener noreferrer">
      <span>{module.link_label}</span>
    </a>
  </div>
);

const isSkinnyBannerModule = module => module.title && module.title.startsWith('SkinnyBanner -');

export default withAdminModule(SkinnyBannerView, isSkinnyBannerModule);




// WEBPACK FOOTER //
// ./src/components/promotions/SkinnyBanner.jsx